import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import TrustSignals from './components/TrustSignals';

const LoginPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    if (isAuthenticated === 'true') {
      navigate('/dashboard');
    }
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>Login - InventoryTracker | Secure Business Inventory Management</title>
        <meta name="description" content="Sign in to your InventoryTracker account. Secure access to comprehensive inventory management tools for your business operations." />
        <meta name="keywords" content="inventory login, business management, secure access, inventory tracking" />
      </Helmet>
      <div className="min-h-screen bg-background">
        {/* Main Content Container */}
        <div className="container mx-auto px-4 py-8 lg:py-12">
          {/* Header Section */}
          <LoginHeader />

          {/* Login Form Section */}
          <div className="flex justify-center mb-16">
            <LoginForm />
          </div>

          {/* Trust Signals Section */}
          <TrustSignals />
        </div>

        {/* Footer */}
        <footer className="border-t border-border bg-card mt-16">
          <div className="container mx-auto px-4 py-8">
            <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
              <div className="text-sm text-muted-foreground">
                © {new Date()?.getFullYear()} InventoryTracker. All rights reserved.
              </div>
              <div className="flex items-center space-x-6 text-sm text-muted-foreground">
                <a href="#" className="hover:text-foreground transition-hover">Privacy Policy</a>
                <a href="#" className="hover:text-foreground transition-hover">Terms of Service</a>
                <a href="#" className="hover:text-foreground transition-hover">Support</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default LoginPage;